/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Scene_Description_CcprjInputs */



/**
* | output |
* | --- |
* | "Import Shot Descriptions" |
*
* @param {Import_Scene_Description_CcprjInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_scene_description_ccprj = /** @type {((inputs?: Import_Scene_Description_CcprjInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Scene_Description_CcprjInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descriptions des plans d'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import Shot Beschreibungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizioni delle foto di importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание импортированных кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripciones de tomas de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入镜头描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートショットの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrições de fotos de importação")
	return /** @type {LocalizedString} */ ("Import Shot Descriptions")
});